<div class="checkout-reseller">
    <div class="checkout-reseller-wrapper">
        <div class="db-subscription-plan-wrapper">
            <db-subscription-info
                    [subscription]="choosedSubscription"
                    [companyInfo]="companyInfo"
                    [user]="user"
                    [renew]="renew"
                    [showPeriodToggle]="hasBothPlans()"
                    [selectedPeriod]="selectedPeriod"
                    [monthlyPlan]="monthlyPlan"
                    [yearlyPlan]="yearlyPlan"
                    [onPeriodChange]="togglePeriod.bind(this)"
            ></db-subscription-info>
        </div>
        @if (user) {
            <div class="db-payment-info-wrapper show">
                <div class="db-payment-info">
                    <div class="db-payment-info__header mb24">
                        <h3 class="db-payment-info__title" [innerHTML]="'text_paymentInfo' | dbText"></h3>
                        <div class="db-payment-info__payments-methods" [class.db-mobile]="isMobile">
                            <div>
                                <img src="assets/images/logos/payment/mastercard-new.svg" alt="Mastercard">
                                <img src="assets/images/logos/payment/visa-new.svg" alt="Visa">
                                <img src="assets/images/logos/payment/amex-new.svg" alt="Amex">
                                <img src="assets/images/logos/payment/discover-new.svg" alt="Discover">
                            </div>
                            <div>
                                @if (!isPayPalProvider) {
                                    <img src="assets/images/logos/payment/stripe-new.svg" alt="Stripe">
                                }
                            </div>
                        </div>
                    </div>
                    <!-- Tabs for switching between existing cards and adding new card -->
                    @if ((renew || recharge || currentSubscription?.platformPaidClient) && paymentMethods?.length) {
                        <div class="checkout-form__tabs">
                            <h4 [ngClass]="{'active': activeTab === 'existingCards'}"
                                (click)="changeTab('existingCards')">{{'text_paymentExistingCards' | dbText}}</h4>
                            <h4 [ngClass]="{'active': activeTab === 'addCard'}"
                                (click)="changeTab('addCard')">{{'text_paymentAddCard' | dbText}}</h4>
                        </div>
                    }
                    @if (selectedPaymentMethod && activeTab === 'existingCards') {
                         <db-payment-method-item [fromCheckout]="true" [fromUpgrade]="true" [withShadow]="true" [paymentMethod]="selectedPaymentMethod" [selectable]="false" [selected]="false" ></db-payment-method-item>
                    }
                    <!-- Add new payment method -->
                    @if ((!renew && !recharge && !currentSubscription?.platformPaidClient) || (activeTab === 'addCard')) {
                        <!-- Stripe Payment Element -->
                        @if (!isPayPalProvider) {
                            <div id="payment-element" class="embedded-payment-element"></div>
                            <div id="confirm-errors"></div>
                        }
                        <!-- PayPal Card Fields -->
                        @if (isPayPalProvider) {
                            <div class="paypal-card-fields">
                                <div class="paypal-field-group">
                                    <label>{{ 'text_cardNumber' | dbText }}</label>
                                    <div id="paypal-card-number-field" class="paypal-card-field"></div>
                                </div>
                                <div class="paypal-field-row">
                                    <div class="paypal-field-group">
                                        <label>{{ 'text_expireDate' | dbText }}</label>
                                        <div id="paypal-card-expiry-field" class="paypal-card-field"></div>
                                    </div>
                                    <div class="paypal-field-group">
                                        <label>CID/CVV</label>
                                        <div id="paypal-card-cvv-field" class="paypal-card-field"></div>
                                    </div>
                                </div>
                            </div>
                        }
                        @if (loadingStripe) {
                            <db-loading-screen></db-loading-screen>
                        }
                    }
                </div>
            </div>
        } @else {
            <div class="db-checkout-steps">{{step}}. {{step === 1 ? ('text_accountDetailsStep' | dbText) : ('text_paymentAndCheckout' | dbText)}} <span>{{step}}/2</span></div>
            <div class="account-info" [class.show]="step === 1">
                <div class="db-account-info-wrapper">
                    <form [formGroup]="checkoutForm" autocomplete="none">
                        <div class="auth-checkout__form">
                            <div class="auth-checkout__group">
                                @if (!user) {
                                    <div class="db-checkout__account-info">
                                    <div class="db-checkout__account-title mb24">
                                        <h3 [innerHTML]="'text_accountInfo' | dbText"></h3>
                                    </div>
                                    <div class="auth-checkout__group-content">
                                        <div class="auth-checkout__group auth-checkout__flname">

                                            <div class="ds-input-wrap">
                                                <input type="email" maxlength="100" name="email" formControlName="email"
                                                       [readonly]="invitationData && invitationData.client_email"
                                                       [class.disabled]="invitationData && invitationData.client_email"
                                                       [style.border-color]="checkoutForm?.controls?.email?.errors?.invitationError
                                                       || (emailChecked && !userDoesNotExist && !serverErrors?.fields?.email)
                                                       || (checkoutForm?.controls?.email?.invalid && ((checkoutForm?.controls?.email?.dirty
                                                       && !checkoutForm?.controls?.email?.errors?.required) || formSubmitted))
                                                       || serverErrors?.fields?.email ? '#D41125' : null" x-autocompletetype="email"
                                                       class="ds-input-black sl-sign_up_email_field"
                                                       [placeholder]="'text_createProfileEmailCheckout' | dbText"
                                                       (ngModelChange)="resetEmailCheck()">
                                                @if (checkoutForm?.controls?.email?.errors?.invitationError) {
                                                    <span class="ds-input-error-msg">{{checkoutForm?.controls?.email?.errors?.invitationError}}</span>
                                                }
                                                @if (!checkoutForm?.controls?.email?.errors?.invitationError && checkoutForm?.controls?.email?.invalid
                                                && ((checkoutForm?.controls?.email?.dirty && !checkoutForm?.controls?.email?.errors?.required)
                                                || formSubmitted) && !(!userDoesNotExist && !serverErrors?.fields?.email)) {
                                                    <span class="ds-input-error-msg">{{'text_invalidEmail' | dbText}}</span>
                                                }
                                                @if (!checkoutForm?.controls?.email?.errors?.invitationError && emailChecked && !userDoesNotExist && !serverErrors?.fields?.email) {
                                                    <span class="ds-input-error-msg">{{'text_existEmail' | dbText}}</span>
                                                }
                                                @if (!checkoutForm?.controls?.email?.errors?.invitationError && serverErrors?.fields?.email) {
                                                    <span class="ds-input-error-msg">{{serverErrors?.fields?.email}}</span>
                                                }
                                            </div>

                                            <div class="ds-input-wrap">
                                                <div class="auth-checkout__password-show-hide">
                                                    <input maxlength="128" [type]="showPassword ? 'text' : 'password'" name="password" formControlName="password" [style.border-color]="(checkoutForm?.controls?.password?.invalid && ((checkoutForm?.controls?.password?.dirty && !checkoutForm?.controls?.password?.errors?.required) || formSubmitted)) ? '#D41125' : null" x-autocompletetype="new-password" class=" ds-input-black sl-sign_up_password_field" [placeholder]="user ? 'text_loginPassword' : 'text_createProfilePassword' | dbText"  (focus)="showPWDRequirements = true" (focusout)="showPWDRequirements = false" (ngModelChange)="progressPercent()">
                                                    <i class="db-icon db-icon-eye{{showPassword ? '-hide' : ''}}" (click)="showPassword = !showPassword" [title]="showPassword ? 'Hide password' : 'Show password'"></i>
                                                </div>
                                                @if ((checkoutForm?.controls?.password?.invalid && ((checkoutForm?.controls?.password?.dirty && !checkoutForm?.controls?.password?.errors?.required) || formSubmitted) ) || serverErrors?.fields?.password) {
                                                    <span class="ds-input-error-msg">{{serverErrors?.fields?.password || ('text_invalidPassword1' | dbText)}}</span>
                                                }
                                                @if (showPWDRequirements) {
                                                    <db-password-validation [formGroup]="checkoutForm"></db-password-validation>
                                                }
                                            </div>
                                        </div>
                                        <div class="auth-checkout__group auth-checkout__flname">
                                            <div class="ds-input-wrap">
                                                <input type="text" maxlength="60" name="fname" id="fname" formControlName="firstName" [style.border-color]="(checkoutForm?.controls?.firstName?.invalid && ((checkoutForm?.controls?.firstName?.dirty && !checkoutForm?.controls?.firstName?.errors?.required) || formSubmitted)) || serverErrors?.fields?.name ? '#D41125' : null" x-autocompletetype="given-name" class="ds-input-black sl-sign_up_firstname_field" [placeholder]="'text_createProfileFirstName' | dbText">
                                                @if ((checkoutForm?.controls?.firstName?.invalid && ((checkoutForm?.controls?.firstName?.dirty && !checkoutForm?.controls?.firstName?.errors?.required) || formSubmitted))  ||  serverErrors?.fields?.first_name) {
                                                    <span class="ds-input-error-msg">{{serverErrors?.fields?.first_name ? serverErrors?.fields?.first_name : (checkoutForm?.controls?.firstName?.errors?.link ? ('text_invalidFirstName' | dbText) : ('text_emptyFirstName' | dbText))}}</span>
                                                }
                                            </div>

                                            <div class="ds-input-wrap">
                                                <input type="text" maxlength="60" name="lname" formControlName="lastName" [style.border-color]="checkoutForm?.controls?.lastName?.invalid && ((checkoutForm?.controls?.lastName?.dirty && !checkoutForm?.controls?.lastName?.errors?.required) || formSubmitted) ? '#D41125' : null" x-autocompletetype="family-name" class="ds-input-black sl-sign_up_lastname_field" [placeholder]="'text_createProfileLastName' | dbText">
                                                @if (checkoutForm?.controls?.lastName?.invalid && ((checkoutForm?.controls?.lastName?.dirty && !checkoutForm?.controls?.lastName?.errors?.required) || formSubmitted) || serverErrors?.fields?.last_name) {
                                                    <span class="ds-input-error-msg">{{serverErrors?.fields.last_name ? serverErrors?.fields?.last_name : (checkoutForm?.controls?.lastName?.errors?.link ? ('text_invalidLastName' | dbText) : ('text_emptyLastName' | dbText))}}</span>
                                                }
                                            </div>
                                        </div>

                                        @if (!checkoutForm?.controls?.email?.invalid && serverErrors?.fields?.email && formSubmitted) {
                                            <div class="auth-checkout__group already-have__group">
                                                <p>{{'text_alreadyHaveAnAccount' | dbText}}<a [routerLink]="['/login/']">Login</a></p>
                                            </div>
                                        }
                                    </div>
                                    </div>
                                }
                            </div>
                        </div>

                    </form>
                </div>
            </div>
            <div class="db-payment-info-wrapper" [class.show]="step === 2">
                <div class="db-payment-info">
                    <h3 [innerHTML]="'text_paymentInfo' | dbText" class="mb24"></h3>
                    <!-- Stripe Payment Element -->
                    @if (!isPayPalProvider) {
                        <div id="payment-element" class="embedded-payment-element"></div>
                        <div id="confirm-errors"></div>
                    }
                    <!-- PayPal Card Fields -->
                    @if (isPayPalProvider) {
                        <div class="paypal-card-fields">
                            <div class="paypal-field-group">
                                <label>{{ 'text_cardNumber' | dbText }}</label>
                                <div id="paypal-card-number-field" class="paypal-card-field"></div>
                            </div>
                            <div class="paypal-field-row">
                                <div class="paypal-field-group">
                                    <label>{{ 'text_expireDate' | dbText }}</label>
                                    <div id="paypal-card-expiry-field" class="paypal-card-field"></div>
                                </div>
                                <div class="paypal-field-group">
                                    <label>CID/CVV</label>
                                    <div id="paypal-card-cvv-field" class="paypal-card-field"></div>
                                </div>
                            </div>
                        </div>
                    }
                    @if (loadingStripe) {
                        <db-loading-screen></db-loading-screen>
                    }
                </div>
            </div>
            <button class="ds-btn-outline m right" [class.show]="step === 1"
                    [class.ds-btn-disabled]="checkoutForm.invalid || (emailChecked && !userDoesNotExist)"
                    [disabled]="checkoutForm.invalid || (emailChecked && !userDoesNotExist)"
                    (click)="initCheckout()">
                @if (!loadingStripe) {
                    <span>{{'text_continueToPayment' | dbText}}</span>
                    <i class="db-icon db-icon-hide-notification ml8"></i>
                } @else {
                    <db-loading-circular-spinner color="dark"></db-loading-circular-spinner>
                }
            </button>
            @if (!loadingStripe) {
                <button class="ds-btn-outline m left" [class.show]="step === 2" (click)="goBackToStep1()">
                    <i class="db-icon db-icon-hide-notification mr8"></i>
                    <span>{{'text_backToAccountInfo' | dbText}}</span>
                </button>
            }

        }

    </div>
    <div class="db-checkout-summary">
        <db-checkout-summary [user]="user"
                             [currentSubscription]="currentSubscription"
                             [choosedSubscription]="choosedSubscription"
                             [renew]="renew || recharge"
                             [companyInfo]="companyInfo"
                             [proRatedCredits]="proRatedCredits"
        ></db-checkout-summary>
        <button class="ds-btn-black ds-btn-max"
                [class.ds-btn-disabled]="(step === 1 && !user) || proRatedCreditLoading || (!user && companyInfo?.branding?.require_tos_consent && !checkoutForm.get('terms_privacy_consent_accepted')?.value)"
                [class.ds-loading]="proRatedCreditLoading" (click)="checkout()"
                [disabled]="(step === 1 && !user) || proRatedCreditLoading || (!user && companyInfo?.branding?.require_tos_consent && !checkoutForm.get('terms_privacy_consent_accepted')?.value)">
            @if (loading || proRatedCreditLoading) {
                <db-loading-circular-spinner></db-loading-circular-spinner>
            } @else {
                @if (!isPayPalProvider) {
                    <span>{{ 'text_secureCheckout' | dbText}}</span>
                } @else if (isPayPalProvider && !paypalOrderApproved) {
                    <span>{{ 'text_verifyCheckout' | dbText}}</span>
                } @else {
                    <span>{{ 'text_completeCheckout' | dbText}}</span>
                }
            }
        </button>
        <p class="cancel-anytime">{{ 'text_upgradePlanStarterCancelAnytime' | dbText}}</p>
        @if (companyInfo?.branding?.terms_and_conditions_link || companyInfo?.branding?.privacy_policy) {
            <p class="checkout-terms">
                @if (companyInfo?.branding?.require_tos_consent && !user) {
                    <label class="checkbox-label mr8">
                        <input type="checkbox"
                               [checked]="checkoutForm.get('terms_privacy_consent_accepted')?.value"
                               (change)="onTosConsentChange($event)">
                    </label>
                }
                <span>{{'text_bySigningUpYouAgree' | dbText: {companyName: companyInfo?.branding?.company_name || companyInfo?.agency?.name} }}
              @if (companyInfo?.branding?.terms_and_conditions_link) {
                <a [href]="companyInfo.branding.terms_and_conditions_link" target="_blank" class="ds-link">Terms of Service</a>
              }
              @if (companyInfo?.branding?.terms_and_conditions_link && companyInfo?.branding?.privacy_policy) {
                <span> {{'text_and' | dbText}} </span>
              }
              @if (companyInfo?.branding?.privacy_policy) {
                <a [href]="companyInfo.branding.privacy_policy" target="_blank" class="ds-link">Privacy Policy</a>
              }</span></p>
        }
    </div>
    <img class="db-logo" [src]="companyInfo?.branding?.cache_icon_big || 'assets/images/logos/logo_placeholder.png'" />
</div>
